const login = () => ({});
export default login;



// WEBPACK FOOTER //
// ./book/src/login/loginDucks.js